/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy } from './get-card-transactions200-response-merged-transaction-detail-list-inner-evidence-list-inner-created-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors } from './get-card-transactions200-response-merged-transaction-detail-list-inner-evidence-list-inner-errors';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer } from './get-card-transactions200-response-merged-transaction-detail-list-inner-evidence-list-inner-invoice-issuer';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy } from './get-card-transactions200-response-merged-transaction-detail-list-inner-evidence-list-inner-updated-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy } from './get-card-transactions200-response-merged-transaction-detail-list-inner-evidence-list-inner-uploaded-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings } from './get-card-transactions200-response-merged-transaction-detail-list-inner-evidence-list-inner-warnings';

/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'cardTransactionEvidenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'paymentType': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'electronicMethod': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'documentSize': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'detectedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'calculatedDpi': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradation': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'verticalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'horizontalPixels': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'heightMillis': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'widthMillis': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'legalValidity': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'dpiForciblyValid': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'colorGradationForciblyValid': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'note': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'irrelevantToLedger': boolean;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'invoiceIssuer': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerInvoiceIssuer | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'dpiError': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'detectedDpiError': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'calculatedDpiError': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'colorGradationError': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'heightMillisError': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     * @deprecated
     */
    'widthMillisError': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'errors': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerErrors;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'warnings': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'createdBy': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCreatedBy;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedBy': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUpdatedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedBy': GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerUploadedBy;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedByRecipient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'needsMigration': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInner
     */
    'uploadedFrom': string;
}

export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = {
    cardTransaction: 'CARD_TRANSACTION',
    paymentRequest: 'PAYMENT_REQUEST'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerPaymentTypeEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = {
    fullElectronic: 'FULL_ELECTRONIC',
    originallyPaper: 'ORIGINALLY_PAPER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerElectronicMethodEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = {
    overA4: 'OVER_A4',
    a4OrSmaller: 'A4_OR_SMALLER',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDocumentSizeEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = {
    valid: 'VALID',
    invalid: 'INVALID',
    inputRequired: 'INPUT_REQUIRED',
    outOfTarget: 'OUT_OF_TARGET'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerLegalValidityEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDpiErrorEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerDetectedDpiErrorEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerCalculatedDpiErrorEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerColorGradationErrorEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerHeightMillisErrorEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWidthMillisErrorEnum];


